import React, {MouseEvent} from 'react';
import {To, useHref} from 'react-router';
import {useCustomNavigate} from '@di-shared/features/navigate/useCustomNavigate';

export interface LinkToProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  to: To;
  onClickBypass?: (e: MouseEvent) => void;
}

function LinkTo({to, onClickBypass, onClick, children, ...rest}: LinkToProps): JSX.Element {
  const href = useHref(to);
  const {navigateTo} = useCustomNavigate();

  return (
    <a
      href={href}
      {...rest}
      onClick={(e) => {
        if (e.metaKey || e.shiftKey || e.altKey || e.ctrlKey) {
          // 새창 열기는 사용자 뜻대로 a 태그를 타고 새창으로 자연스럽게 열리게끔
          return;
        }
        if (onClickBypass) {
          onClickBypass(e);
        }
        if (onClick) {
          // 커스텀 온클릭이 있다면 그것을 우선
          onClick(e);
          return;
        }
        e.preventDefault();
        navigateTo(to);
      }}
    >
      {children}
    </a>
  );
}

export default LinkTo;
